import { render } from "./DecimalInput.vue?vue&type=template&id=621ee78a&ts=true"
import script from "./DecimalInput.vue?vue&type=script&lang=ts"
export * from "./DecimalInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__